import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "rectangular-bathroom-sink",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Rectangular Bathroom Sink",
    description: "rectangular-bathroom-sink",
    image: require("./rectangular-bathroom-sink.svg"),
    svgIcon: require("./rectangular-bathroom-sink.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              class="cls-1"
              d="M50,5.6H3.46A2.1,2.1,0,0,0,1.05,8V94.3c0,1.67.76,2.4,2.48,2.4H96.34C98.25,96.7,99,96,99,94.13V8.1c0-1.8-.73-2.5-2.58-2.5Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              d="M50,5.6H96.37c1.85,0,2.58.7,2.58,2.5v86c0,1.89-.7,2.57-2.61,2.57H3.53c-1.72,0-2.48-.73-2.48-2.4V8A2.1,2.1,0,0,1,3.46,5.6ZM38.71,22.17c0,2.31,0,4.84,0,7.37A6.08,6.08,0,0,1,38,32.28a3.13,3.13,0,0,1-1.86,1.26,1.78,1.78,0,0,1-2-1.24,8.51,8.51,0,0,1-.62-2.76c-.09-2.46,0-4.92,0-7.08-.82-.23-1.47-.39-2.11-.59a5.83,5.83,0,0,0-1.37-.5c-5.28,0-10.55,0-15.83,0H13.13V84.83h73.7V21.43a3.32,3.32,0,0,0-.39-.07H68.91a2.53,2.53,0,0,0-.71.13c-.63.2-1.25.41-2,.68V23c0,2.23.08,4.46,0,6.68a6.66,6.66,0,0,1-.79,2.91,2,2,0,0,1-3.52,0,6.67,6.67,0,0,1-.8-2.91c-.12-2.22,0-4.45,0-6.67a5,5,0,0,0,0-.6c-.74-.13-1.51-.05-1.85-.39a2.41,2.41,0,0,0-2-.64c-1.2,0-2.4,0-3.59,0H51.41c0,3.28,0,6.36,0,9.44,0,1.23-.28,1.53-1.29,1.54s-1.23-.69-1.23-1.51V21.35H41.34a2.57,2.57,0,0,0-.69.2Zm30.58-2.32h17c1.52,0,1.71.18,1.71,1.64q0,31.67,0,63.31c0,1.41-.2,1.59-1.65,1.59H13.71c-1.57,0-1.75-.17-1.75-1.72V21.57c0-1.5.23-1.72,1.77-1.72H29.78c.34,0,.86-.07,1-.29.91-1.32,1.75-2.7,2.6-4.07a1.1,1.1,0,0,0,.25-.54,3.41,3.41,0,0,0-2.41-2.08H7.79c-.34,0-.68,0-1,.07V90H93.22V12.86H91.8c-7.43,0-14.85.06-22.28,0-1.66,0-2.66.47-3.26,2,.52.72,1.13,1.47,1.63,2.29S68.76,18.79,69.29,19.85ZM96.7,93.67v-85H69.15v2H92.63c2,0,2.31.35,2.31,2.27V90a7.48,7.48,0,0,1,0,.82,1.53,1.53,0,0,1-1.63,1.48q-43.29,0-86.59,0c-.64,0-1.13-.17-1.34-.74A4.42,4.42,0,0,1,5.06,90q0-36.9,0-73.8v-3.6c0-1.47.52-2,2-2H30.91l.41-2h-28v85ZM48.83,19.81V18.23c-2.09-.33-2.09-.33-2.09-2.43V12.86a43.57,43.57,0,0,1-4.87,0c-1.72-.19-2.48.67-3,2,.91,1.7,2.66,2.91,2.71,5Zm2.65,0c2.11,0,4.21,0,6.31,0a.7.7,0,0,0,.48-.29q1.17-1.82,2.28-3.66c.2-.33.58-.84.46-1-.44-.71-1-1.79-1.62-1.88a45,45,0,0,0-5.83-.09v3.94c0,.85-.33,1.38-1.31,1.3a5.4,5.4,0,0,0-.77.05Zm12.13-1.43a4.64,4.64,0,0,0-1.55,3.93c.11,2.29,0,4.58,0,6.87a8.52,8.52,0,0,0,.1,1.43c.13.77.58,1.51,1.39,1.37.52-.1,1-.8,1.34-1.34a3,3,0,0,0,.13-1.41c0-2.46-.08-4.92,0-7.38A4.43,4.43,0,0,0,63.61,18.41Zm-27.47,0a4.62,4.62,0,0,0-1.54,3.54c.13,2.46,0,4.92,0,7.38a3.24,3.24,0,0,0,.16,1.51c.3.5.86,1.11,1.36,1.16s1-.64,1.26-1.13a3.53,3.53,0,0,0,.18-1.61c0-2.46-.08-4.92,0-7.37A4.44,4.44,0,0,0,36.14,18.4ZM47.9,10.25v6.39l1-.11c0-.92,0-1.74,0-2.55s.28-1.31,1.22-1.32,1.29.5,1.3,1.34,0,1.69,0,2.61l1-.06v-6.3Zm-6.24.31h5l.45-1.9h-5.4ZM58.77,8.69H53.24l.46,1.88h4.66ZM35.46,12.43c-.61-.84-1.17-1.7-1.83-2.49a3.53,3.53,0,0,0-1.05-.58c-.1.49-.46,1.11-.28,1.44a33.84,33.84,0,0,0,2.17,3.06Zm27.45,0c-.62-.85-1.19-1.72-1.85-2.51-.23-.27-.7-.36-1.05-.53-.12.43-.48,1-.32,1.27.64,1.1,1.45,2.11,2.23,3.22ZM50.27,14.34H50.1V30.69h.17ZM38,15.92c-1,1.45-1,1.45-.09,2.68.36.51.71,1,1.1,1.51s1,.5,1.2-.21a1.56,1.56,0,0,0-.18-1.14C39.45,17.8,38.74,16.9,38,15.92Zm26.45,1.43c.7.95,1.33,1.86,2,2.73.14.19.49.43.65.37a1,1,0,0,0,.58-.62,1.36,1.36,0,0,0-.13-1c-.65-1-1.38-1.93-2.11-2.94ZM38,13.54l.82-1.11a19.45,19.45,0,0,0,1.58-2.29c.16-.29-.09-.78-.15-1.19a3.31,3.31,0,0,0-.91.51c-.53.63-.94,1.36-1.49,2S37.07,12.82,38,13.54Zm27.47,0c.8-1.11,1.64-2.19,2.36-3.35.18-.28,0-.8-.07-1.2a3.11,3.11,0,0,0-1,.49c-.54.62-.94,1.37-1.49,2A1.21,1.21,0,0,0,65.5,13.55ZM34.44,16.2c-.39.52-.75,1-1.09,1.45a17.79,17.79,0,0,0-1.33,2c-.14.29.06.75.11,1.13a3.06,3.06,0,0,0,1-.49c.55-.62.94-1.38,1.5-2S35.28,16.93,34.44,16.2Zm27.43,0c-.8,1.12-1.65,2.2-2.37,3.35-.17.28.06.8.11,1.21a3.15,3.15,0,0,0,1-.54c.54-.62.94-1.37,1.49-2S62.7,16.9,61.87,16.2ZM38.37,8.7H34.19c.91.73.94,2,2.17,1.92S37.6,9.42,38.37,8.7ZM62,8.6l-.11.28c.69.54.71,1.78,2,1.74s1.24-1.2,2-1.93c-.46,0-.69-.09-.92-.09ZM35.15,15l1,.89A4.05,4.05,0,0,0,37,14.7c.06-.22-.41-.58-.64-.88ZM62.6,15l1,.92a4.48,4.48,0,0,0,.85-1.2c.06-.22-.41-.59-.64-.89Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M38.71,22.17l1.94-.61a2.57,2.57,0,0,1,.69-.2h7.55v9.47c0,.82.12,1.53,1.23,1.51s1.29-.31,1.29-1.54c0-3.08,0-6.16,0-9.44h2.11c1.19,0,2.39,0,3.59,0a2.41,2.41,0,0,1,2,.64c.34.34,1.11.26,1.85.39a5,5,0,0,1,0,.6c0,2.22-.08,4.45,0,6.67a6.67,6.67,0,0,0,.8,2.91,2,2,0,0,0,3.52,0,6.66,6.66,0,0,0,.79-2.91c.11-2.22,0-4.45,0-6.68v-.78c.79-.27,1.41-.48,2-.68a2.53,2.53,0,0,1,.71-.13H86.44a3.32,3.32,0,0,1,.39.07v63.4H13.13V21.35h1.09c5.28,0,10.55,0,15.83,0a5.83,5.83,0,0,1,1.37.5c.64.2,1.29.36,2.11.59,0,2.16-.06,4.62,0,7.08a8.51,8.51,0,0,0,.62,2.76,1.78,1.78,0,0,0,2,1.24A3.13,3.13,0,0,0,38,32.28a6.08,6.08,0,0,0,.66-2.74C38.76,27,38.71,24.48,38.71,22.17Zm16.12,48A7.28,7.28,0,0,0,53,65,3.75,3.75,0,0,0,47.25,65a8,8,0,0,0,.13,10.46,3.69,3.69,0,0,0,5.49,0A7.3,7.3,0,0,0,54.83,70.13Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M69.29,19.85c-.53-1.06-.91-1.93-1.4-2.73s-1.11-1.57-1.63-2.29c.6-1.54,1.6-2,3.26-2,7.43.1,14.85,0,22.28,0h1.42V90H6.74v-77c.37,0,.71-.07,1-.07H31.23a3.41,3.41,0,0,1,2.41,2.08,1.1,1.1,0,0,1-.25.54c-.85,1.37-1.69,2.75-2.6,4.07-.15.22-.67.28-1,.29h-16c-1.54,0-1.77.22-1.77,1.72v63.1c0,1.55.18,1.72,1.75,1.72H86.35c1.45,0,1.65-.18,1.65-1.59q0-31.65,0-63.31c0-1.46-.19-1.64-1.71-1.64h-17Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M96.7,93.67H3.31v-85h28l-.41,2H7c-1.47,0-2,.51-2,2v3.6q0,36.9,0,73.8a4.42,4.42,0,0,0,.31,1.56c.21.57.7.74,1.34.74q43.29,0,86.59,0a1.53,1.53,0,0,0,1.63-1.48,7.48,7.48,0,0,0,0-.82V12.9c0-1.92-.36-2.27-2.31-2.27H69.15v-2H96.7Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M48.83,19.81h-7.3c-.05-2.12-1.8-3.33-2.71-5,.57-1.29,1.33-2.15,3-2a43.57,43.57,0,0,0,4.87,0V15.8c0,2.1,0,2.1,2.09,2.43Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M51.48,19.84V18.17a5.4,5.4,0,0,1,.77-.05c1,.08,1.31-.45,1.31-1.3V12.88a45,45,0,0,1,5.83.09c.63.09,1.18,1.17,1.62,1.88.12.19-.26.7-.46,1q-1.11,1.84-2.28,3.66a.7.7,0,0,1-.48.29C55.69,19.85,53.59,19.84,51.48,19.84Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M63.61,18.41a4.43,4.43,0,0,1,1.48,3.47c-.12,2.46,0,4.92,0,7.38a3,3,0,0,1-.13,1.41c-.32.54-.82,1.24-1.34,1.34-.81.14-1.26-.6-1.39-1.37a8.52,8.52,0,0,1-.1-1.43c0-2.29.08-4.58,0-6.87A4.64,4.64,0,0,1,63.61,18.41Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M36.14,18.4a4.44,4.44,0,0,1,1.5,3.48c-.12,2.45,0,4.91,0,7.37a3.53,3.53,0,0,1-.18,1.61c-.26.49-.87,1.16-1.26,1.13s-1.06-.66-1.36-1.16a3.24,3.24,0,0,1-.16-1.51c0-2.46.09-4.92,0-7.38A4.62,4.62,0,0,1,36.14,18.4Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M47.9,10.25h4.49v6.3l-1,.06c0-.92,0-1.77,0-2.61s-.32-1.36-1.3-1.34S48.9,13.2,48.89,14s0,1.63,0,2.55l-1,.11Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M41.66,10.56V8.66h5.4l-.45,1.9Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M58.77,8.69l-.41,1.88H53.7l-.46-1.88Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M35.46,12.43l-1,1.43A33.84,33.84,0,0,1,32.3,10.8c-.18-.33.18-1,.28-1.44a3.53,3.53,0,0,1,1.05.58C34.29,10.73,34.85,11.59,35.46,12.43Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M62.91,12.42l-1,1.45c-.78-1.11-1.59-2.12-2.23-3.22-.16-.28.2-.84.32-1.27.35.17.82.26,1.05.53C61.72,10.7,62.29,11.57,62.91,12.42Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M50.27,14.34V30.68H50.1V14.33Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M38,15.92c.71,1,1.42,1.88,2,2.84a1.56,1.56,0,0,1,.18,1.14c-.17.71-.72.79-1.2.21s-.74-1-1.1-1.51C37,17.37,37,17.37,38,15.92Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M64.48,17.35l1-1.43c.73,1,1.46,2,2.11,2.94a1.36,1.36,0,0,1,.13,1,1,1,0,0,1-.58.62c-.16.06-.51-.18-.65-.37C65.81,19.21,65.18,18.3,64.48,17.35Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M38,13.54c-1-.72-.79-1.37-.15-2.1s1-1.35,1.49-2A3.31,3.31,0,0,1,40.28,9c.06.41.31.9.15,1.19a19.45,19.45,0,0,1-1.58,2.29Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M65.5,13.55a1.21,1.21,0,0,1-.18-2.08c.55-.61,1-1.36,1.49-2a3.11,3.11,0,0,1,1-.49c0,.4.25.92.07,1.2C67.14,11.36,66.3,12.44,65.5,13.55Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M34.44,16.2c.84.73.86,1.34.18,2.07s-.95,1.36-1.5,2a3.06,3.06,0,0,1-1,.49c-.05-.38-.25-.84-.11-1.13a17.79,17.79,0,0,1,1.33-2C33.69,17.18,34.05,16.72,34.44,16.2Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M61.87,16.2c.83.7.89,1.3.22,2s-1,1.36-1.49,2a3.15,3.15,0,0,1-1,.54c0-.41-.28-.93-.11-1.21C60.22,18.4,61.07,17.32,61.87,16.2Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M38.37,8.7c-.77.72-.82,1.88-2,1.92S35.1,9.43,34.19,8.7Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M62,8.6H64.9c.23,0,.46,0,.92.09-.76.73-.82,1.88-2,1.93s-1.26-1.2-2-1.74Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M35.15,15l1.18-1.19c.23.3.7.66.64.88a4.05,4.05,0,0,1-.83,1.2Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M62.6,15l1.19-1.17c.23.3.7.67.64.89a4.48,4.48,0,0,1-.85,1.2Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              d="M54.83,70.13a7.3,7.3,0,0,1-2,5.26,3.69,3.69,0,0,1-5.49,0A8,8,0,0,1,47.25,65,3.75,3.75,0,0,1,53,65,7.28,7.28,0,0,1,54.83,70.13Zm-8.33.66A5.21,5.21,0,0,0,47.83,74a2.86,2.86,0,0,0,4.55,0,6.17,6.17,0,0,0-.06-7.87,2.89,2.89,0,0,0-4.43,0A6.19,6.19,0,0,0,46.5,70.79Z"
              transform="translate(-1.05 -5.6)"
            />
            <path
              class="cls-1"
              d="M46.5,70.79a6.19,6.19,0,0,1,1.39-4.61,2.89,2.89,0,0,1,4.43,0A6.17,6.17,0,0,1,52.38,74a2.86,2.86,0,0,1-4.55,0A5.21,5.21,0,0,1,46.5,70.79Z"
              transform="translate(-1.05 -5.6)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },
  render3D: function (element, layer, scene) {},
};
